import * as STD                            from '@emersya/mpa-std-lib';
import { Image }                           from '@emersya/mpa-components-lib';
import EngineModule                        from '../EngineModule';
import { NS as PlannerLayoutOptionTileNS } from '../components/viewer/planner/layout/OptionTile/PlannerLayoutOptionTile';
import { NS as LayoutEditorNS }            from '../components/viewer/planner/layout/Editor/PlannerLayoutEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'viewer-planner-layout-editor',
	dependencies :     [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers : null,
	modulesBefore :    [ 'product-editor' ],
	modulesAfter :     [ 'viewer-planner-furniture-editor' ],
	usableCondition :  {
		type :      'notequal',
		component : 'K.basket',
		property :  'TARGET.basket.currentProduct',
		value :     null
	},
	displayCondition : {
		type : 'or',
		LHS :  {
			type :      'equal',
			component : 'K',
			property :  '[*]TARGET.hasThisModuleUsed("standing-customerMode")',
			value :     false
		},
		RHS :  {
			type :      'notequal',
			component : 'K',
			property :  '[*]TARGET.parameters.mode',
			value :     'client'
		}
	},
	generateComponentConfiguration() {
		return (<LayoutEditorNS.Configuration> {
			shapes : Object.entries(this.configuration).
							 filter(x => x[ 0 ].startsWith('has-shape') && x[ 1 ] === 'x').
							 reduce<Record<string, PlannerLayoutOptionTileNS.Configuration>>((a, c) => {
								 const currentTrad = this.translations[ c[ 0 ].replace('has-', '') ];
								 if (!currentTrad) {
									 throw STD.errors.user('');
								 }
								 const currentIconURL = this.configuration[ 'iconURL' + c[ 0 ].replace('has', '') ];
								 if (!currentIconURL) {
									 throw STD.errors.user('');
								 }
								 a[ c[ 0 ].replace('has-', '') ] = {
									 iconURL :                currentIconURL,
									 '@innerConfigurations' : {
										 'image' : <Image.Configuration> {
											 '@translations' : {
												 'name' : currentTrad
											 },
											 'URL' :           currentIconURL
										 },
										 'title' : {
											 '@translations' : {
												 'text' : currentTrad
											 }
										 }
									 }
								 };
								 return a;
							 }, {})
		});
	},
	initialize() {

	}
});
